__turbopack_context__.v({
  "aboutheading1": "upsc-mains-test-series-2023-module__QzX0KG__aboutheading1",
  "aboutparagraph1": "upsc-mains-test-series-2023-module__QzX0KG__aboutparagraph1",
  "aboutparagraph2": "upsc-mains-test-series-2023-module__QzX0KG__aboutparagraph2",
  "acheivername": "upsc-mains-test-series-2023-module__QzX0KG__acheivername",
  "acheiverrank": "upsc-mains-test-series-2023-module__QzX0KG__acheiverrank",
  "acheiverrank1": "upsc-mains-test-series-2023-module__QzX0KG__acheiverrank1",
  "acheiverrank2": "upsc-mains-test-series-2023-module__QzX0KG__acheiverrank2",
  "acheiverrank3": "upsc-mains-test-series-2023-module__QzX0KG__acheiverrank3",
  "acheiverrank4": "upsc-mains-test-series-2023-module__QzX0KG__acheiverrank4",
  "acheiverrankspecial": "upsc-mains-test-series-2023-module__QzX0KG__acheiverrankspecial",
  "acheivertitle": "upsc-mains-test-series-2023-module__QzX0KG__acheivertitle",
  "admissionBtn": "upsc-mains-test-series-2023-module__QzX0KG__admissionBtn",
  "ansheet": "upsc-mains-test-series-2023-module__QzX0KG__ansheet",
  "bgboxbg": "upsc-mains-test-series-2023-module__QzX0KG__bgboxbg",
  "blink": "upsc-mains-test-series-2023-module__QzX0KG__blink",
  "bodred": "upsc-mains-test-series-2023-module__QzX0KG__bodred",
  "captcha": "upsc-mains-test-series-2023-module__QzX0KG__captcha",
  "checkIcon": "upsc-mains-test-series-2023-module__QzX0KG__checkIcon",
  "checkboxcontent": "upsc-mains-test-series-2023-module__QzX0KG__checkboxcontent",
  "compareTable": "upsc-mains-test-series-2023-module__QzX0KG__compareTable",
  "contactbox": "upsc-mains-test-series-2023-module__QzX0KG__contactbox",
  "contactboxheight": "upsc-mains-test-series-2023-module__QzX0KG__contactboxheight",
  "contactheader": "upsc-mains-test-series-2023-module__QzX0KG__contactheader",
  "contactsubcontent": "upsc-mains-test-series-2023-module__QzX0KG__contactsubcontent",
  "content": "upsc-mains-test-series-2023-module__QzX0KG__content",
  "dark": "upsc-mains-test-series-2023-module__QzX0KG__dark",
  "dot": "upsc-mains-test-series-2023-module__QzX0KG__dot",
  "downloadicon": "upsc-mains-test-series-2023-module__QzX0KG__downloadicon",
  "facultyborder3": "upsc-mains-test-series-2023-module__QzX0KG__facultyborder3",
  "featureCard": "upsc-mains-test-series-2023-module__QzX0KG__featureCard",
  "featureCol": "upsc-mains-test-series-2023-module__QzX0KG__featureCol",
  "featureText": "upsc-mains-test-series-2023-module__QzX0KG__featureText",
  "featureTitle": "upsc-mains-test-series-2023-module__QzX0KG__featureTitle",
  "formstar": "upsc-mains-test-series-2023-module__QzX0KG__formstar",
  "gshad": "upsc-mains-test-series-2023-module__QzX0KG__gshad",
  "iconCircle": "upsc-mains-test-series-2023-module__QzX0KG__iconCircle",
  "iconWrap": "upsc-mains-test-series-2023-module__QzX0KG__iconWrap",
  "imagee": "upsc-mains-test-series-2023-module__QzX0KG__imagee",
  "img": "upsc-mains-test-series-2023-module__QzX0KG__img",
  "imgboxbelow": "upsc-mains-test-series-2023-module__QzX0KG__imgboxbelow",
  "invalidCheck2": "upsc-mains-test-series-2023-module__QzX0KG__invalidCheck2",
  "mainTitle": "upsc-mains-test-series-2023-module__QzX0KG__mainTitle",
  "mbtableheading": "upsc-mains-test-series-2023-module__QzX0KG__mbtableheading",
  "medalicon": "upsc-mains-test-series-2023-module__QzX0KG__medalicon",
  "mobileApplyBtn": "upsc-mains-test-series-2023-module__QzX0KG__mobileApplyBtn",
  "mobileBadge": "upsc-mains-test-series-2023-module__QzX0KG__mobileBadge",
  "mobileInfoBox": "upsc-mains-test-series-2023-module__QzX0KG__mobileInfoBox",
  "mobileMainTitle": "upsc-mains-test-series-2023-module__QzX0KG__mobileMainTitle",
  "mobilePdfBtn": "upsc-mains-test-series-2023-module__QzX0KG__mobilePdfBtn",
  "mobilePlanBody": "upsc-mains-test-series-2023-module__QzX0KG__mobilePlanBody",
  "mobilePlanCard": "upsc-mains-test-series-2023-module__QzX0KG__mobilePlanCard",
  "mobilePlanHeader": "upsc-mains-test-series-2023-module__QzX0KG__mobilePlanHeader",
  "mobileSubTitle": "upsc-mains-test-series-2023-module__QzX0KG__mobileSubTitle",
  "mobileWrapper": "upsc-mains-test-series-2023-module__QzX0KG__mobileWrapper",
  "mobilemaillinks": "upsc-mains-test-series-2023-module__QzX0KG__mobilemaillinks",
  "modernCard": "upsc-mains-test-series-2023-module__QzX0KG__modernCard",
  "more": "upsc-mains-test-series-2023-module__QzX0KG__more",
  "normalbutton": "upsc-mains-test-series-2023-module__QzX0KG__normalbutton",
  "normalbutton1": "upsc-mains-test-series-2023-module__QzX0KG__normalbutton1",
  "normalbutton2": "upsc-mains-test-series-2023-module__QzX0KG__normalbutton2",
  "numberbold": "upsc-mains-test-series-2023-module__QzX0KG__numberbold",
  "pagemaintitle": "upsc-mains-test-series-2023-module__QzX0KG__pagemaintitle",
  "paybill": "upsc-mains-test-series-2023-module__QzX0KG__paybill",
  "pdfBtn": "upsc-mains-test-series-2023-module__QzX0KG__pdfBtn",
  "phoneiconcss": "upsc-mains-test-series-2023-module__QzX0KG__phoneiconcss",
  "planCard": "upsc-mains-test-series-2023-module__QzX0KG__planCard",
  "planCol": "upsc-mains-test-series-2023-module__QzX0KG__planCol",
  "prebg": "upsc-mains-test-series-2023-module__QzX0KG__prebg",
  "presbg": "upsc-mains-test-series-2023-module__QzX0KG__presbg",
  "program": "upsc-mains-test-series-2023-module__QzX0KG__program",
  "redunderline": "upsc-mains-test-series-2023-module__QzX0KG__redunderline",
  "redunderlinealink": "upsc-mains-test-series-2023-module__QzX0KG__redunderlinealink",
  "sectionredtitle": "upsc-mains-test-series-2023-module__QzX0KG__sectionredtitle",
  "sectionsubtitle": "upsc-mains-test-series-2023-module__QzX0KG__sectionsubtitle",
  "sectiontitle": "upsc-mains-test-series-2023-module__QzX0KG__sectiontitle",
  "sectiontitle1": "upsc-mains-test-series-2023-module__QzX0KG__sectiontitle1",
  "sectiontitle2": "upsc-mains-test-series-2023-module__QzX0KG__sectiontitle2",
  "subText": "upsc-mains-test-series-2023-module__QzX0KG__subText",
  "tableHeader": "upsc-mains-test-series-2023-module__QzX0KG__tableHeader",
  "tableRow": "upsc-mains-test-series-2023-module__QzX0KG__tableRow",
  "tablebg": "upsc-mains-test-series-2023-module__QzX0KG__tablebg",
  "tableheading": "upsc-mains-test-series-2023-module__QzX0KG__tableheading",
  "tablepara": "upsc-mains-test-series-2023-module__QzX0KG__tablepara",
  "tablepara1": "upsc-mains-test-series-2023-module__QzX0KG__tablepara1",
  "tablescroll": "upsc-mains-test-series-2023-module__QzX0KG__tablescroll",
  "tablinks": "upsc-mains-test-series-2023-module__QzX0KG__tablinks",
  "tablinks1": "upsc-mains-test-series-2023-module__QzX0KG__tablinks1",
  "tabscrollclass": "upsc-mains-test-series-2023-module__QzX0KG__tabscrollclass",
  "tabsection": "upsc-mains-test-series-2023-module__QzX0KG__tabsection",
  "topGlow": "upsc-mains-test-series-2023-module__QzX0KG__topGlow",
  "topTag": "upsc-mains-test-series-2023-module__QzX0KG__topTag",
  "toppersupsc": "upsc-mains-test-series-2023-module__QzX0KG__toppersupsc",
  "ulclass": "upsc-mains-test-series-2023-module__QzX0KG__ulclass",
  "ulliclass": "upsc-mains-test-series-2023-module__QzX0KG__ulliclass",
  "ullispan": "upsc-mains-test-series-2023-module__QzX0KG__ullispan",
  "viewbutton": "upsc-mains-test-series-2023-module__QzX0KG__viewbutton",
  "whatsnewkeyanimation": "upsc-mains-test-series-2023-module__QzX0KG__whatsnewkeyanimation",
});
